import React from 'react';
import { Typography } from '@/components/common';

export const ReplyToClientIntro: React.FC = () => (
	<>
		<hr className="mb-4 border-grey-100" />
		<Typography type="semibold-18" className="text-left">
			Reply to Client
		</Typography>
		<Typography type="regular-14" className="text-gray-35 text-left mt-1 mb-4">
			Message client regarding this document. If you ask the client to resubmit,
			this version of the document will be archived and replaced by the new
			version.
		</Typography>
	</>
);
